import React from "react";

// Motivo da marca (flor de 6 petalas + gota) reaproveitado do simbolo que
// ja existe no Footer. Extraido pra asset compartilhado pra poder ser usado
// em outras paginas (ex: banner da Quem Somos) com cores customizaveis,
// sem duplicar os paths do SVG original.
// preserveAspectRatio default mantem a proporcao original (nao distorce) —
// o PageHero passa "none" de proposito, porque a caixa do banner e mais
// alta que larga (proporcao medida no Figma) e o SVG precisa esticar pra
// acompanhar, em vez de ficar com espaco vazio dos lados.
export const BrandFlower = ({
  petalColor = "#3B5FA6",
  dropColor = "#00ACEC",
  preserveAspectRatio = "xMidYMid meet",
}) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 68 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    preserveAspectRatio={preserveAspectRatio}
    style={{ display: "block" }}
  >
    <path
      d="M7.07516 54.0429C6.66676 53.5385 6.28977 53.0341 5.97561 52.4666C4.24776 49.4717 4.342 45.9566 5.81854 43.1508C7.13799 40.6287 9.50987 38.8318 12.3216 38.3274L30.6369 35.0645L23.5055 52.309C22.406 54.9572 20.1441 56.8802 17.4109 57.6368C14.3636 58.4723 10.9236 57.8102 8.37891 55.4773C7.90767 55.036 7.48357 54.5631 7.09087 54.0587"
      fill={petalColor}
    />
    <path
      d="M33.9981 67.0004C33.3541 67.0004 32.7258 66.9846 32.0818 66.8743C28.6732 66.3384 26.0029 64.0685 24.7462 61.1682C23.6153 58.5515 23.6938 55.5724 25.0604 53.0661L33.9981 36.6885L42.9359 53.0661C44.3025 55.5724 44.381 58.5515 43.25 61.1682C41.9934 64.0843 39.3231 66.3541 35.9145 66.8743C35.2705 66.9689 34.6422 67.0004 33.9981 67.0004Z"
      fill={dropColor}
    />
    <path
      d="M18.9974 1.14284C19.5786 0.859112 20.1598 0.606906 20.7724 0.417751C24.071 -0.59107 27.4639 0.29165 29.8515 2.37234C31.9878 4.23236 33.213 6.95933 33.0716 9.8124L32.1134 28.4598L16.9711 17.5992C14.6463 15.9284 13.2955 13.2802 13.1698 10.4429C13.0441 7.27459 14.4579 4.05897 17.301 2.10437C17.835 1.74183 18.4005 1.44234 18.966 1.1586"
      fill={petalColor}
    />
    <path
      d="M48.9372 1.12697C49.5184 1.4107 50.0682 1.69443 50.6179 2.07274C53.461 4.02733 54.8905 7.24295 54.7648 10.4113C54.6548 13.2486 53.304 15.9125 50.9792 17.5834L35.8683 28.4755L34.8787 9.82805C34.7216 6.97498 35.9468 4.24801 38.0831 2.38799C40.4707 0.307299 43.8636 -0.57542 47.1622 0.417639C47.7905 0.606793 48.356 0.859 48.9372 1.14273"
      fill={petalColor}
    />
    <path
      d="M67.6611 24.6295C67.8025 25.2601 67.9282 25.8748 67.9753 26.5368C68.2266 29.9889 66.6087 33.1099 64.064 34.9857C61.7707 36.6723 58.8648 37.2556 56.1159 36.4832L38.209 31.4076L52.1261 19.018C54.2624 17.1107 57.1369 16.3856 59.9329 16.89C63.043 17.4575 65.839 19.5697 67.1271 22.7853C67.3627 23.3843 67.5355 23.999 67.6768 24.6295"
      fill={petalColor}
    />
    <path
      d="M60.9681 53.9958C60.5597 54.5002 60.1513 54.9731 59.6801 55.4144C57.1354 57.7631 53.6954 58.4251 50.6481 57.5897C47.9149 56.8331 45.6373 54.91 44.5378 52.2776L37.375 35.0488L55.706 38.2802C58.5177 38.7689 60.8739 40.5816 62.209 43.0879C63.6856 45.8937 63.7955 49.4088 62.0677 52.4037C61.7378 52.9712 61.3608 53.4756 60.9681 53.98"
      fill={petalColor}
    />
    <path
      d="M0.336864 24.6448C0.478234 24.0142 0.635312 23.3995 0.886637 22.8005C2.15897 19.5849 4.97066 17.4727 8.0651 16.8894C10.8611 16.3693 13.7356 17.1101 15.8719 19.0017L29.8047 31.3913L11.8978 36.4827C9.14894 37.2708 6.243 36.6718 3.94966 34.9852C1.40499 33.1094 -0.21291 29.9884 0.0227073 26.5363C0.0698308 25.89 0.195493 25.2595 0.336864 24.629"
      fill={petalColor}
    />
  </svg>
);

export default BrandFlower;
